import { put } from 'redux-saga/effects';
import { setDeclarationSubmitted } from 'modules/Taps/components/NDFL3Light/redux/actions';

export default function* submitSaga() {
  yield put(setDeclarationSubmitted());
}
